import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDOWxBw25RlQVU_Bc16cw18tUb92AvnKjc",
  authDomain: "prontuarioeletronico-ef718.firebaseapp.com",
  projectId: "prontuarioeletronico-ef718",
  storageBucket: "prontuarioeletronico-ef718.firebasestorage.app",
  messagingSenderId: "91161818778",
  appId: "1:91161818778:web:62b8adc45438c2fb61d123",
  measurementId: "G-2BN7GT7HGP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);